import React from 'react';
import { cn } from '../../lib/utils';

const Button = React.forwardRef(({ className, variant = 'default', size = 'default', ...props }, ref) => {
 const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors active:scale-[0.97] active:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
 
 const variants = {
 default: 'bg-primary text-primary-foreground hover:bg-primary/90',
 destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
 outline: 'border border-input hover:bg-accent hover:text-accent-foreground',
ghost: 'hover:bg-accent hover:text-accent-foreground',
 link: 'underline-offset-4 hover:underline text-primary',
 };
 
 const sizes = {
 default: 'h-10 py-2 px-4',
 sm: 'h-9 px-3 ',
 lg: 'h-11 px-8 ',
 icon: 'h-10 w-10',
 };
 
 return (
 <button
 className={cn(baseStyles, variants[variant], sizes[size], className)}
 ref={ref}
 {...props}
 />
 );
});

Button.displayName = 'Button';

export default Button;

